import { MailSendItem } from '../../types/MailSendItem';
import createInfiniteScrollStore from '../infiniteScrollStore';

export const useMailSentStore = createInfiniteScrollStore<MailSendItem>();
